import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=23163500&scoped=true"
import script from "./goods.vue?vue&type=script&lang=ts"
export * from "./goods.vue?vue&type=script&lang=ts"
import style0 from "./goods.vue?vue&type=style&index=0&id=23163500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23163500",
  null
  
)

export default component.exports